// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O6hM1Koz34fNjRfL {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/PermissionTagGroup/index.modules.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".tagUnauthorized {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagUnauthorized": `O6hM1Koz34fNjRfL`
};
export default ___CSS_LOADER_EXPORT___;
